import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAccessControlStore } from '../stores/accessControlStore';
import RouteBlockModal from '../components/organism/RouteBlockModal';
import { isRouteAllowed } from './routeAccess';

interface IRouteAccessGuard {
  children: ReactNode;
}

/**
 * Bloqueia o acesso a áreas que não estão na lista de hrefs liberados
 * (permissions.platformModules). Quando bloqueado, a página NÃO é renderizada:
 * mostra um modal de vendas cuja única saída é voltar para /minha-area.
 */
export const RouteAccessGuard = ({ children }: IRouteAccessGuard) => {
  const location = useLocation();
  const navigate = useNavigate();
  const platformModules = useAccessControlStore((state) => state.platformModules);

  if (!isRouteAllowed(location.pathname, platformModules)) {
    return (
      <>
        {/* Mantém a plataforma ao fundo, borrada e sem interação. */}
        <div className='pointer-events-none select-none blur-md' aria-hidden>
          {children}
        </div>
        <RouteBlockModal
          onBack={() => navigate('/minha-area')}
          platformModules={platformModules}
        />
      </>
    );
  }

  return <>{children}</>;
};
